import httpApiApplication from '../../../../../http/httpApiApplication';

import { type ReportCell } from './types';

export const baseUrl = '/reportcells';

export function updateReportCell(id: string, request: ReportCell) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function deleteReportCell(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}

export const createReportCell = (request: ReportCell) => {
  return httpApiApplication.post(baseUrl, request);
};
